import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { memo } from "react";
import { NavRoutes } from "@jutro/router";
import { ScrollToTop } from "@jutro/platform";
var AppFloorPlanContentInternal = function AppFloorPlanContentInternal(_ref) {
  var _context,
    _ref$routes = _ref.routes,
    routes = void 0 === _ref$routes ? [] : _ref$routes,
    _ref$sideRoutes = _ref.sideRoutes,
    sideRoutes = void 0 === _ref$sideRoutes ? [] : _ref$sideRoutes,
    excludeScrollToTopRoutes = _ref.excludeScrollToTopRoutes,
    _ref$componentMap = _ref.componentMap,
    componentMap = void 0 === _ref$componentMap ? {} : _ref$componentMap,
    allRoutes = _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(routes), _toConsumableArray(sideRoutes));
  return allRoutes.length <= 0 ? null : React.createElement(React.Fragment, null, React.createElement(ScrollToTop, {
    excludeRoutes: excludeScrollToTopRoutes
  }), React.createElement(NavRoutes, {
    resolveComponentMap: componentMap,
    routes: allRoutes
  }));
};
AppFloorPlanContentInternal.displayName = "AppFloorPlanContent";
export var AppFloorPlanContent = memo(AppFloorPlanContentInternal);
AppFloorPlanContentInternal.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "AppFloorPlanContent",
  props: {
    routes: {
      defaultValue: {
        value: "[]",
        computed: !1
      },
      required: !1
    },
    sideRoutes: {
      defaultValue: {
        value: "[]",
        computed: !1
      },
      required: !1
    },
    componentMap: {
      defaultValue: {
        value: "{}",
        computed: !1
      },
      required: !1
    }
  }
}, AppFloorPlanContentInternal.__docgenInfo = {
  componentName: "AppFloorPlanContent",
  packageName: "@jutro/floorplan",
  description: "",
  displayName: "AppFloorPlanContent",
  methods: [],
  actualName: "AppFloorPlanContentInternal",
  props: {
    routes: {
      defaultValue: {
        value: "[]",
        computed: !1
      },
      required: !1
    },
    sideRoutes: {
      defaultValue: {
        value: "[]",
        computed: !1
      },
      required: !1
    },
    componentMap: {
      defaultValue: {
        value: "{}",
        computed: !1
      },
      required: !1
    }
  }
};